import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const departmentsManagementReducer = foxGridReducer(
  gridNames.departmentsManagement,
);

export default departmentsManagementReducer;
